/**
 * diamore-appointments.js
 * Stepper de 4 pasos para reserva de citas — Diamore Joyeros
 */

(function () {
  'use strict';

  const CF_URL = 'https://diamore-proxy.diamorejoyeros.workers.dev';

  // ─── Estado global ──────────────────────────────────────────────────────────

  const state = {
    step:     1,
    type:     null,   // 'PRESENCIAL' | 'VIRTUAL' | etc.
    duration: null,   // minutos
    date:     null,   // 'YYYY-MM-DD'
    slot:     null,   // { start: '10:30', end: '11:15' }
    name:     '',
    phone:    '',
    email:    '',
    cedula:   '',
    interest: '',
    budget:   '',
    notes:    '',
  };

  // Nombres legibles
  const TYPE_LABELS = {
    PRESENCIAL:    'Consulta presencial',
    VIRTUAL:       'Videollamada (Google Meet)',
    RECOGIDA:      'Recogida de pieza',
    REPARACION:    'Reparación de joya',
    RETIRO_TALLER: 'Retiro de orden',
  };

  const INTEREST_LABELS = {
    'anillo-compromiso': 'Anillo de compromiso',
    'banda':             'Banda de matrimonio',
    'joyeria':           'Joyería (aretes, collar, pulsera)',
    'taller':            'Servicio de taller / reparación',
    'otro':              'Otro',
  };

  const BUDGET_LABELS = {
    '2000':  '$2,000 – $5,000',
    '5000':  '$5,000 – $10,000',
    '10000': '$10,000 – $20,000',
    '20000': '$20,000+',
  };

  const MESES = [
    'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
    'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre',
  ];

  const DIAS = ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'];

  // Calendario: mes visualizado
  let calYear  = null;
  let calMonth = null;

  // Días con slots disponibles para el mes actual (null = aún no cargado)
  let availableDays = null;

  // ─── Inicialización ─────────────────────────────────────────────────────────

  function init() {
    const root = document.getElementById('dm-appt');
    if (!root) return;

    const now = new Date();
    calYear  = now.getFullYear();
    calMonth = now.getMonth();

    // Paso 1 — selección de tipo
    root.querySelectorAll('.dm-appt__type-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        root.querySelectorAll('.dm-appt__type-btn').forEach(b => b.classList.remove('dm-appt__type-btn--active'));
        btn.classList.add('dm-appt__type-btn--active');
        state.type     = btn.dataset.type;
        state.duration = parseInt(btn.dataset.duration, 10);
        // Invalidar disponibilidad del mes al cambiar tipo (duración diferente)
        availableDays = null;
        // Habilitar botón continuar
        const nextBtn = root.querySelector('[data-panel="1"] .dm-appt__next');
        if (nextBtn) nextBtn.disabled = false;
      });
    });

    // Navegación: botones "Continuar" y "Atrás"
    root.querySelectorAll('.dm-appt__next').forEach(btn => {
      btn.addEventListener('click', () => {
        const panel = btn.closest('[data-panel]');
        const current = parseInt(panel.dataset.panel, 10);
        if (current === 3 && !validateStep3()) return;
        if (!isNaN(current)) goToStep(current + 1);
      });
    });

    root.querySelectorAll('.dm-appt__back').forEach(btn => {
      btn.addEventListener('click', () => {
        const panel = btn.closest('[data-panel]');
        const current = parseInt(panel.dataset.panel, 10);
        if (!isNaN(current) && current > 1) goToStep(current - 1);
      });
    });

    // Calendario — navegación de mes
    root.querySelector('.dm-appt__cal-prev')?.addEventListener('click', () => {
      calMonth--;
      if (calMonth < 0) { calMonth = 11; calYear--; }
      availableDays = null;
      renderCalendarGrid(calYear, calMonth);
      fetchMonthAvailability(calYear, calMonth);
    });

    root.querySelector('.dm-appt__cal-next')?.addEventListener('click', () => {
      calMonth++;
      if (calMonth > 11) { calMonth = 0; calYear++; }
      availableDays = null;
      renderCalendarGrid(calYear, calMonth);
      fetchMonthAvailability(calYear, calMonth);
    });

    // Paso 3 — campos
    setupStep3Events(root);

    // Confirmar cita
    document.getElementById('dm-appt-confirm')?.addEventListener('click', confirmAppointment);
  }

  // ─── 1. goToStep ────────────────────────────────────────────────────────────

  function goToStep(n) {
    const root   = document.getElementById('dm-appt');
    const panels = root.querySelectorAll('.dm-appt__panel');
    const steps  = root.querySelectorAll('.dm-appt__step');
    const lines  = root.querySelectorAll('.dm-appt__step-line');

    // Mostrar panel correcto
    panels.forEach(p => {
      const key = p.dataset.panel;
      if (key === String(n) || key === n) {
        p.removeAttribute('hidden');
      } else {
        p.setAttribute('hidden', '');
      }
    });

    // Actualizar indicadores de paso
    if (typeof n === 'number') {
      state.step = n;
      steps.forEach((s, i) => {
        const stepNum = i + 1;
        s.classList.toggle('dm-appt__step--active',    stepNum === n);
        s.classList.toggle('dm-appt__step--completed', stepNum < n);
      });
      lines.forEach((line, i) => {
        line.classList.toggle('dm-appt__step-line--completed', i < n - 1);
      });
    }

    // Acciones al entrar en un paso
    if (n === 2) {
      renderCalendarGrid(calYear, calMonth);
      if (availableDays === null) {
        fetchMonthAvailability(calYear, calMonth);
      } else {
        // Datos ya cargados — aplicar disponibilidad sin re-fetch
        applyAvailability(availableDays);
      }
    }
    if (n === 3) {
      updateFieldsForType(state.type);
    }
    if (n === 4) {
      renderSummary();
      // Reset error
      const err = document.getElementById('dm-appt-error');
      if (err) { err.hidden = true; err.textContent = ''; }
    }

    // Scroll al inicio del stepper
    document.getElementById('dm-appt')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // ─── 2. renderCalendarGrid — solo estructura, nunca espera API ─────────────

  function renderCalendarGrid(year, month) {
    const container = document.getElementById('dm-appt-calendar');
    const label     = document.querySelector('.dm-appt__cal-month');
    if (!container) return;

    if (label) label.textContent = `${MESES[month]} ${year}`;

    const today     = new Date();
    today.setHours(0, 0, 0, 0);
    // Mínimo: mañana a la misma hora (regla 24h del worker)
    const minDate   = new Date(today.getTime() + 24 * 60 * 60 * 1000);

    // month es 0-based (Enero=0 … Diciembre=11), igual que lo devuelve getMonth()
    const primerDia   = new Date(year, month, 1);
    const firstDay    = (primerDia.getDay() + 6) % 7; // Lun-primero: Dom→6, Lun→0 … Sáb→5
    const daysInMonth = new Date(year, month + 1, 0).getDate();

    // Deshabilitar navegación a meses pasados
    const prevBtn = document.querySelector('.dm-appt__cal-prev');
    if (prevBtn) {
      const isCurrentMonth = year === today.getFullYear() && month === today.getMonth();
      prevBtn.disabled = isCurrentMonth;
    }

    let html = '<div class="dm-appt__cal-grid">';

    // Cabecera de días
    DIAS.forEach(d => {
      html += `<div class="dm-appt__cal-header">${d}</div>`;
    });

    // Celdas vacías iniciales
    for (let i = 0; i < firstDay; i++) {
      html += '<div class="dm-appt__cal-empty"></div>';
    }

    // Días del mes — solo isPast/isSunday; disponibilidad la aplica applyAvailability
    for (let d = 1; d <= daysInMonth; d++) {
      const date    = new Date(year, month, d);
      const dateStr = formatDate(year, month + 1, d);
      const dow     = date.getDay();

      const isPast     = date < minDate;
      const isSunday   = dow === 0;
      const isSelected = state.date === dateStr;
      const isToday    = date.toDateString() === today.toDateString();
      const disabled   = isPast || isSunday;

      let cls = 'dm-appt__cal-day';
      if (disabled)   cls += ' dm-appt__cal-day--disabled';
      if (isSunday)   cls += ' dm-appt__cal-day--sunday';
      if (isSelected) cls += ' dm-appt__cal-day--selected';
      if (isToday)    cls += ' dm-appt__cal-day--today';

      // Seguro de respaldo: el día 1 fija su columna explícitamente (LUN=1…DOM=7)
      const colStyle = (d === 1) ? ` style="grid-column-start:${firstDay + 1}"` : '';
      html += `<button type="button" class="${cls}"${colStyle} data-date="${dateStr}"${disabled ? ' disabled aria-disabled="true"' : ''}>${d}</button>`;
    }

    html += '</div>';
    container.innerHTML = html;

    // Eventos de click en días
    container.querySelectorAll('.dm-appt__cal-day:not([disabled])').forEach(btn => {
      btn.addEventListener('click', () => {
        state.date = btn.dataset.date;
        state.slot = null;

        // Resaltar día seleccionado
        container.querySelectorAll('.dm-appt__cal-day').forEach(b => b.classList.remove('dm-appt__cal-day--selected'));
        btn.classList.add('dm-appt__cal-day--selected');

        // Deshabilitar continuar hasta elegir slot
        const panel2Next = document.querySelector('[data-panel="2"] .dm-appt__next');
        if (panel2Next) panel2Next.disabled = true;

        fetchSlots(state.date);
      });
    });
  }

  // ─── 2b. applyAvailability — solo pinta clases, nunca redibuja el grid ──────

  function applyAvailability(available) {
    const container = document.getElementById('dm-appt-calendar');
    if (!container) return;

    container.querySelectorAll('.dm-appt__cal-day[data-date]').forEach(btn => {
      if (!available.has(btn.dataset.date)) {
        btn.classList.add('dm-appt__cal-day--no-slots', 'dm-appt__cal-day--disabled');
        btn.disabled = true;
        btn.setAttribute('aria-disabled', 'true');
      }
    });
  }

  // ─── 2c. fetchMonthAvailability — loading + timeout + applyAvailability ─────

  async function fetchMonthAvailability(year, month) {
    if (!state.type) {
      console.warn('[Appt] fetchMonthAvailability llamado sin tipo');
    }

    const loadingId = 'dm-appt-cal-loading';
    const label     = document.querySelector('.dm-appt__cal-month');

    // Mostrar "Verificando disponibilidad..."
    if (label && !document.getElementById(loadingId)) {
      const el = document.createElement('p');
      el.id        = loadingId;
      el.className = 'dm-appt__slots-loading';
      el.style.cssText = 'font-size:11px;letter-spacing:1px;text-align:center;margin:4px 0 0;';
      el.textContent   = 'Verificando disponibilidad...';
      label.parentNode.insertBefore(el, label.nextSibling);
    }

    function removeLoading() {
      document.getElementById(loadingId)?.remove();
    }

    // Timeout de seguridad: si el API no responde en 10 s, limpiar indicator
    const timeout = setTimeout(removeLoading, 10000);

    try {
      const url = `${CF_URL}/appointments/availability/month?year=${year}&month=${month + 1}&type=${state.type}`;
      const res  = await fetch(url);
      clearTimeout(timeout);
      removeLoading();
      if (!res.ok) return;
      const data = await res.json();
      if (Array.isArray(data.availableDates)) {
        availableDays = new Set(data.availableDates);
        applyAvailability(availableDays);
      }
    } catch (e) {
      clearTimeout(timeout);
      removeLoading();
      console.warn('[appointments] fetchMonthAvailability error:', e);
    }
  }

  // ─── 3. fetchSlots ──────────────────────────────────────────────────────────

  async function fetchSlots(date) {
    const container = document.getElementById('dm-appt-slots');
    if (!container) return;

    container.innerHTML = '<p class="dm-appt__slots-loading">Cargando horarios...</p>';

    try {
      const url = `${CF_URL}/appointments/availability?date=${date}&type=${state.type}`;
      const res = await fetch(url);
      const data = await res.json();

      if (!res.ok || !data.slots) {
        container.innerHTML = '<p class="dm-appt__slots-error">No se pudieron cargar los horarios. Intenta de nuevo.</p>';
        return;
      }

      if (!data.isOpen) {
        container.innerHTML = '<p class="dm-appt__slots-hint">No atendemos ese día. Selecciona un día hábil (lunes a sábado).</p>';
        return;
      }

      const available = data.slots.filter(s => s.available);

      if (available.length === 0) {
        container.innerHTML = '<p class="dm-appt__slots-hint">Sin horarios disponibles para este día. Prueba otra fecha.</p>';
        return;
      }

      let html = '<div class="dm-appt__slots-grid">';
      data.slots.forEach(slot => {
        const cls = slot.available ? 'dm-appt__slot' : 'dm-appt__slot dm-appt__slot--taken';
        const disabled = slot.available ? '' : ' disabled aria-disabled="true"';
        const isSelected = state.slot && state.slot.start === slot.start;
        const selectedCls = isSelected ? ' dm-appt__slot--selected' : '';
        html += `<button type="button" class="${cls}${selectedCls}" data-start="${slot.start}" data-end="${slot.end}"${disabled}>${slot.start}</button>`;
      });
      html += '</div>';

      container.innerHTML = html;

      // Eventos de click en slots
      container.querySelectorAll('.dm-appt__slot:not([disabled])').forEach(btn => {
        btn.addEventListener('click', () => {
          state.slot = { start: btn.dataset.start, end: btn.dataset.end };
          container.querySelectorAll('.dm-appt__slot').forEach(b => b.classList.remove('dm-appt__slot--selected'));
          btn.classList.add('dm-appt__slot--selected');

          const panel2Next = document.querySelector('[data-panel="2"] .dm-appt__next');
          if (panel2Next) panel2Next.disabled = false;
        });
      });

    } catch (err) {
      console.error('[appointments] fetchSlots error:', err);
      container.innerHTML = '<p class="dm-appt__slots-error">Error de conexión. Verifica tu internet e intenta de nuevo.</p>';
    }
  }

  // ─── 4. renderSummary ───────────────────────────────────────────────────────

  function renderSummary() {
    const container = document.getElementById('dm-appt-summary');
    if (!container) return;

    const dateFormatted = state.date
      ? new Date(state.date + 'T12:00:00').toLocaleDateString('es-CO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })
      : '—';

    const rows = [
      { label: 'Tipo de cita',  value: TYPE_LABELS[state.type] || state.type },
      { label: 'Fecha',         value: dateFormatted },
      { label: 'Hora',          value: state.slot ? `${state.slot.start} – ${state.slot.end}` : '—' },
      { label: 'Nombre',        value: state.name  || '—' },
      { label: 'WhatsApp',      value: state.phone || '—' },
      { label: 'Email',         value: state.email || '—' },
      { label: 'Cédula',        value: state.cedula || '—' },
      { label: 'Interés',       value: INTEREST_LABELS[state.interest] || state.interest || '—' },
    ];

    if (state.budget) {
      rows.push({ label: 'Presupuesto', value: BUDGET_LABELS[state.budget] || state.budget });
    }
    if (state.notes) {
      rows.push({ label: 'Notas', value: state.notes });
    }
    if (state.type === 'VIRTUAL') {
      rows.push({ label: 'Enlace Meet', value: 'Se enviará por email al confirmar' });
    }

    let html = '<dl class="dm-appt__summary-list">';
    rows.forEach(r => {
      html += `<div class="dm-appt__summary-row"><dt>${r.label}</dt><dd>${r.value}</dd></div>`;
    });
    html += '</dl>';

    container.innerHTML = html;
  }

  // ─── 5. confirmAppointment ──────────────────────────────────────────────────

  async function confirmAppointment() {
    const btn = document.getElementById('dm-appt-confirm');
    const err = document.getElementById('dm-appt-error');

    if (btn) { btn.disabled = true; btn.textContent = 'Confirmando...'; }
    if (err) { err.hidden = true; err.textContent = ''; }

    const ordenVal = document.getElementById('appt-orden')?.value?.trim() || '';
    const notasVal = document.getElementById('appt-notes')?.value?.trim() || '';
    const notasFinal = ordenVal
      ? `Orden #${ordenVal}${notasVal ? ' · ' + notasVal : ''}`
      : notasVal || null;

    const body = {
      tipo:        state.type,
      fecha:       state.date,
      hora:        state.slot?.start,
      nombre:      state.name,
      email:       state.email,
      whatsapp:    state.phone,
      cedula:      state.cedula,
      interes:     state.interest,
      presupuesto: state.budget ? parseInt(state.budget, 10) : null,
      notas:       notasFinal,
    };

    try {
      const res  = await fetch(`${CF_URL}/appointments/book`, {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify(body),
      });

      const data = await res.json();

      if (!res.ok) {
        const msg = data.error || 'Error al confirmar la cita. Intenta de nuevo.';
        if (err) { err.textContent = msg; err.hidden = false; }
        if (btn) { btn.disabled = false; btn.textContent = 'Confirmar cita'; }
        return;
      }

      // Éxito
      const appt = data.appointment;
      const dateFormatted = appt.fecha
        ? new Date(appt.fecha + 'T12:00:00').toLocaleDateString('es-CO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })
        : appt.fecha;

      let msg = `Tu cita de <strong>${TYPE_LABELS[appt.tipo] || appt.tipo}</strong> quedó agendada para el <strong>${dateFormatted}</strong> a las <strong>${appt.hora}</strong>.`;
      if (appt.meetLink) {
        msg += `<br><br>🎥 <strong>Link de Google Meet:</strong> <a href="${appt.meetLink}" target="_blank" rel="noopener">${appt.meetLink}</a>`;
      }

      const successMsg = document.getElementById('dm-appt-success-msg');
      if (successMsg) successMsg.innerHTML = msg;

      goToStep('success');

    } catch (e) {
      console.error('[appointments] confirmAppointment error:', e);
      if (err) { err.textContent = 'Error de conexión. Verifica tu internet e intenta de nuevo.'; err.hidden = false; }
      if (btn) { btn.disabled = false; btn.textContent = 'Confirmar cita'; }
    }
  }

  // ─── 6. Campos dinámicos según tipo de cita ─────────────────────────────────

  function updateFieldsForType(tipo) {
    const isTaller = tipo === 'RETIRO_TALLER' ||
                     tipo === 'REPARACION' ||
                     tipo === 'RECOGIDA';

    // Ocultar/mostrar campo interés
    const interestField = document.getElementById('appt-interest');
    const interestWrapper = interestField?.closest('.dm-appt__field');
    if (interestWrapper) {
      interestWrapper.style.display = isTaller ? 'none' : '';
    }

    // Ocultar/mostrar campo presupuesto
    const budgetField = document.getElementById('appt-budget-field');
    if (budgetField) {
      budgetField.style.display = isTaller ? 'none' : '';
    }

    // Cambiar placeholder de notas
    const notesEl = document.getElementById('appt-notes');
    if (notesEl) {
      notesEl.placeholder = isTaller
        ? 'Número de orden u observaciones adicionales...'
        : 'Cuéntanos más sobre lo que buscas...';
    }

    // Campo número de orden (solo para taller)
    const ordenFieldId = 'appt-orden-field';
    let ordenWrap = document.getElementById(ordenFieldId);
    if (isTaller) {
      if (!ordenWrap) {
        ordenWrap = document.createElement('div');
        ordenWrap.className = 'dm-appt__field';
        ordenWrap.id = ordenFieldId;
        ordenWrap.innerHTML =
          '<label class="dm-appt__label" for="appt-orden">Número de orden *</label>' +
          '<input class="dm-appt__input" type="text" id="appt-orden" placeholder="#001122">';
        const notesWrap = notesEl?.closest('.dm-appt__field');
        if (notesWrap) {
          notesWrap.parentNode.insertBefore(ordenWrap, notesWrap);
        }
        // Sincronizar con estado
        document.getElementById('appt-orden')?.addEventListener('input', function () {
          state.notes = (this.value.trim() ? 'Orden: ' + this.value.trim() + '. ' : '') +
            ((document.getElementById('appt-notes')?.value || '').trim());
        });
      }
      ordenWrap.style.display = '';
    } else {
      if (ordenWrap) ordenWrap.style.display = 'none';
    }

    // Limpiar valores irrelevantes al cambiar tipo
    if (isTaller) {
      state.interest = '';
      state.budget   = '';
      const interestEl = document.getElementById('appt-interest');
      const budgetEl   = document.getElementById('appt-budget');
      if (interestEl) interestEl.value = '';
      if (budgetEl)   budgetEl.value   = '';
    }
  }

  // ─── 7. Validación paso 3 ───────────────────────────────────────────────────

  function setupStep3Events(root) {
    const nameEl     = document.getElementById('appt-name');
    const phoneEl    = document.getElementById('appt-phone');
    const emailEl    = document.getElementById('appt-email');
    const cedulaEl   = document.getElementById('appt-cedula');
    const interestEl = document.getElementById('appt-interest');
    const budgetEl   = document.getElementById('appt-budget');
    const notesEl    = document.getElementById('appt-notes');
    const budgetField  = document.getElementById('appt-budget-field');
    const budgetNotice = document.getElementById('appt-budget-notice');

    // Sincronizar campos con estado
    if (nameEl)     nameEl.addEventListener('input',  () => { state.name     = nameEl.value.trim(); });
    if (phoneEl)    phoneEl.addEventListener('input', () => { state.phone    = phoneEl.value.trim(); });
    if (emailEl)    emailEl.addEventListener('input', () => { state.email    = emailEl.value.trim(); });
    if (cedulaEl)   cedulaEl.addEventListener('input',() => { state.cedula   = cedulaEl.value.trim(); });
    if (notesEl)    notesEl.addEventListener('input', () => { state.notes    = notesEl.value.trim(); });

    if (interestEl) {
      interestEl.addEventListener('change', () => {
        state.interest = interestEl.value;
        // Si es taller: ocultar presupuesto
        if (budgetField) {
          budgetField.hidden = (state.interest === 'taller');
          if (state.interest === 'taller') {
            state.budget = '';
            if (budgetEl) budgetEl.value = '';
          }
        }
      });
    }

    if (budgetEl) {
      budgetEl.addEventListener('change', () => {
        state.budget = budgetEl.value;
        // Mostrar aviso si el valor seleccionado implica presupuesto < $2k
        // Todos nuestros rangos parten de $2k, así que solo mostramos si está en blanco
        if (budgetNotice) budgetNotice.hidden = true;
      });
    }
  }

  function validateStep3() {
    state.name     = (document.getElementById('appt-name')?.value   || '').trim();
    state.phone    = (document.getElementById('appt-phone')?.value  || '').trim();
    state.email    = (document.getElementById('appt-email')?.value  || '').trim();
    state.cedula   = (document.getElementById('appt-cedula')?.value || '').trim();
    state.interest = document.getElementById('appt-interest')?.value || '';
    state.budget   = document.getElementById('appt-budget')?.value  || '';
    state.notes    = (document.getElementById('appt-notes')?.value  || '').trim();

    const isTaller    = state.type === 'RETIRO_TALLER' || state.type === 'REPARACION' || state.type === 'RECOGIDA';
    const needsBudget = !isTaller && state.interest !== 'taller' && state.interest !== '';
    const budgetOk    = !needsBudget || state.budget !== '';

    if (!state.name || !state.phone || !state.email || !state.cedula ||
        (!isTaller && !state.interest) || !budgetOk) {
      // Resaltar campos vacíos
      [
        ['appt-name',  state.name],
        ['appt-phone', state.phone],
        ['appt-email', state.email],
        ['appt-cedula',state.cedula],
      ].forEach(([id, val]) => {
        const el = document.getElementById(id);
        if (el) el.classList.toggle('dm-appt__input--error', !val);
      });
      if (!isTaller) {
        const interestEl = document.getElementById('appt-interest');
        if (interestEl) interestEl.classList.toggle('dm-appt__input--error', !state.interest);
        if (needsBudget && !state.budget) {
          document.getElementById('appt-budget')?.classList.add('dm-appt__input--error');
        }
      }
      return false;
    }

    // Validar número de orden obligatorio para tipos de taller
    if (isTaller) {
      const ordenInput = document.getElementById('appt-orden');
      if (!ordenInput || !ordenInput.value.trim()) {
        if (ordenInput) {
          ordenInput.style.outline = '1.5px solid #C0392B';
          setTimeout(() => { ordenInput.style.outline = ''; }, 3000);
        }
        const ordenField = document.getElementById('appt-orden-field');
        if (ordenField && !ordenField.querySelector('.appt-error')) {
          const errMsg = document.createElement('p');
          errMsg.className = 'appt-error';
          errMsg.textContent = 'El número de orden es obligatorio';
          errMsg.style.cssText = 'color:#C0392B;font-size:10px;letter-spacing:1px;font-family:"Josefin Sans",sans-serif;text-transform:uppercase;margin-top:4px;';
          ordenField.appendChild(errMsg);
          setTimeout(() => errMsg.remove(), 3000);
        }
        return false;
      }
    }

    // Limpiar errores
    ['appt-name','appt-phone','appt-email','appt-cedula','appt-interest','appt-budget'].forEach(id => {
      document.getElementById(id)?.classList.remove('dm-appt__input--error');
    });

    return true;
  }

  // ─── Utilidades ─────────────────────────────────────────────────────────────

  function formatDate(year, month, day) {
    return `${year}-${String(month).padStart(2,'0')}-${String(day).padStart(2,'0')}`;
  }

  // ─── Arrancar ───────────────────────────────────────────────────────────────

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
